import PermissionMatrix from "components/permission-matrix/PermissionMatrix";

export default function StaffPermissionsPage() {
  return <PermissionMatrix />;
}
